import {GCPortalkarteBaseClass} from "./class_portalkarte_base";
import {GCPortalkarteDefaultValuesClass} from "./class_defaultvalues";
import {GCPortalkarteWMSLayerInterface} from "./interface/interface_wmslayer";
import {GCPortalkarteGeocoderResponseClass} from "./class_geocoderresponse";
import {GCPortalkarteEditClass} from "./class_portalkarte_edit";
import {GCPortalkarteVectorLayerOptions} from "./interface/interface_vectorlayer_options";

export class GCPortalkarteClass extends GCPortalkarteBaseClass {

    // Die HIT-Funktion ermittelt nur das erste Feature; wenn null, dann werden ALLE Feature gesucht
    public static only_first_feature: 1;

    protected defaultValues: GCPortalkarteDefaultValuesClass;
    //protected jquery: any;
    //protected ol: any;
    //protected proj4: any;
    protected proj4Extent: any;

    protected targetId: string = '';
    protected idCounter: number = 1;


    protected map: any;
    protected backgroundLayer: any;
    protected overviewLayer: any;
    protected backgroundLayerExt: any[];
    protected wmsLayer: any[];
    protected wmsLayerGroup: any[];

    // Hauptlayer für dynamische Daten
    protected featureLayer: any;
    protected featureCounter: number = 0;

    /**
     * TrackingLayer, um Features/Geometrien einzuzeichnen
     * @private
     */
    protected trackingLayer: any;

    // Array mit zusätlich definierten Layern für dynamische Daten
    protected additionalFeatureLayer: any[];

    protected directFeatureLayer: any;
    protected directFeatureCounter: number = 0;

    protected graticuleLayer: any;
    protected overlayLayer: any;


    protected mapControls: any[];
    protected mapInteractions: any[];

    protected pointStyles: object = {};
    protected firstPoint: any = null;

    protected infoUrl:string = '';

    protected getFeatureInfoActive:boolean = false;

    protected url_path_extension: string = '';

    protected debugOn: boolean = false;

    public GeolocationButtonInProgress = false;

    protected restrictedExtent = null;

    protected callAs = 'map';

    /**
     *
     * @param idname
     * @param _options
     */
    public constructor(idname: string, _options: object) {

        super();

        this.targetId       = idname ? idname : 'map';
        //this.jquery         = window['jQuery'] || null;
        //this.ol             = window['ol'] || null;
        //this.proj4          = window['proj4'] || null;
        this.proj4Extent    = null;
        this.defaultValues  = new GCPortalkarteDefaultValuesClass();

        this.backgroundLayerExt = [];
        this.backgroundLayer    = null;

        this.overviewLayer      = null;
        this.featureLayer = null;
        this.additionalFeatureLayer = [];
        this.directFeatureLayer = null;
        this.wmsLayer           = [];
        this.wmsLayerGroup      = [];
        this.graticuleLayer     = null;
        this.overlayLayer       = null;


        this.url_path_extension = '';


        this.mapControls        = [];
        this.mapInteractions    = [];

        let options = {
            controls: this.mapControls,
            interactions: this.mapInteractions
        };
        this.jquery.extend(options, _options);
        this.map = new this.ol.Map(options);
    }

    /**
     * aktiviert/deaktiviert Debug-Ausgaben auf der console
     * @param value
     */
    public setDebug(value: boolean) {
        this.debugOn = value;

        return this;
    }

    /**
     * Zugriff auf den aktellen Layer für dynamische Daten
     */
    public getCurrentLayer() {
        return this.featureLayer;
    }

    /**
     * Zugriff auf den zusätzlichen Feature-Layer mit dem Index "index"
     * @param index
     */
    public getAdditionalFeatureLayer(index: number) {
        index = parseInt(index.toString());
        if (this.additionalFeatureLayer.length > index && index >= 0) {
            return this.additionalFeatureLayer[index];
        }
    }

    /**
     *
     */
    public getAdditionalFeatureLayerLength() {
        return this.additionalFeatureLayer.length;
    }

    /**
     * fügt einen zusätzlichen Featurelayer hinzu
     * @param layer
     */
    public addAdditionalFeatureLayer(layer: any) {
        if (layer) {
            this.additionalFeatureLayer.push(layer);
        }
    }

    /**
     * Ist diese Kartensicht editierbar
     */
    public isEditable() {
        return false;
    }

    /**
     * Dom-ID des Karten-Containers
     */
    public getTargetId() {
        return this.targetId;
    }

    /**
     * Setzt die Dom-ID des Karten-Containers
     * @param targetid
     */
    public setTargetId(targetid: string) {
        this.targetId = targetid;

        return this;
    }

    /**
     *
     */
    public getMaxZoom(): number {
        return this.defaultValues.maxZoom;
    }

    /**
     *
     * @param {number} value
     */
    public setMaxZoom(value: number) {
        this.defaultValues.maxZoom = value;

        return this;
    }

    /**
     *
     */
    public getMaxZoomSteps(): number {
        return this.defaultValues.maxZoomSteps;
    }

    /**
     *
     * @param {number} value
     */
    public setMaxZoomSteps(value: number) {
        this.defaultValues.maxZoomSteps = value;

        return this;
    }

    /**
     *
     */
    public getMinZoomSteps(): number {
        return this.defaultValues.minZoomSteps;
    }

    /**
     *
     * @param {number} value
     */
    public setMinZoomSteps(value: number) {
        this.defaultValues.minZoomSteps = value;

        return this;
    }

    /**
     *
     */
    public getMaxGeocoderZoom(): number {
        if (this.defaultValues.maxGeocoderZoom)
        {
            return this.defaultValues.maxGeocoderZoom;
        }

        return this.defaultValues.maxZoom;
    }

    /**
     *
     * @param {number} value
     */
    public setMaxGeocoderZoom(value: number) {
        this.defaultValues.maxGeocoderZoom = value;

        return this;
    }

    /**
     *
     */
    public getExtentPaddingFactor(): number {
        return this.defaultValues.extentPaddingFactor;
    }

    /**
     *
     * @param {number} value
     */
    public setExtentPaddingFactor(value: number) {
        this.defaultValues.extentPaddingFactor = value;

        return this;
    }

    /**
     *
     */
    public getDuration(): number {
        return this.defaultValues.duration;
    }

    /**
     *
     * @param {number} value
     */
    public setDuration(value: number) {
        this.defaultValues.duration = value;

        return this;
    }

    /**
     *
     */
    public getInfoUrl(): string
    {
        return this.infoUrl;
    }

    /**
     *
     * @param {string} url
     */
    public setInfoUrl(url:string)
    {
        this.infoUrl = url;
        return this;
    }

    /**
     *
     * @param {boolean} value
     */
    public setGetFeatureInfoActive(value:boolean)
    {
        this.getFeatureInfoActive = value;
        return this;
    }


    /**
     *
     */
    public isGetFeatureInfoActive():boolean
    {
        return this.getFeatureInfoActive;
    }

    /**
     *
     */
    public getViewProjection()
    {
        return this.defaultValues.mapViewProjection;
    }

    /**
     *
     * @param {string} value
     */
    public setViewProjection(value: any)
    {
        this.defaultValues.mapViewProjection = value;
        this.registerProjection(value);

        return this;
    }

    /**
     *
     * @param value
     */
    public setRestrictedExtent(value: any)
    {
        this.restrictedExtent = value;

        return this;
    }


    /**
     * Gibt das OL-Map-Objekt zurück
     */
    public getMap() {
        return this.map;
    }


    public getMapExtent()
    {
        return this.map.getView().calculateExtent(this.map.getSize());
    }

    /**
     * Gibt den Feature-Layer zurück
     */
    public getFeatureLayer() {
        return this.featureLayer;
    }


    /**
     * Gibt den Direct-Feature-Layer zurück
     */
    public getDirectFeatureLayer() {
        return this.directFeatureLayer;
    }

    /**
     * Setzt den Direct-Feature-Layer
     */
    public setDirectFeatureLayer(layer: any) {
        this.directFeatureLayer = layer;
    }

    /**
     * Gibt den ERSTEN Hintergrundkarten-Layer zurück (Haupthintergrund)
     */
    public getBackgroundLayer(idname?:string) {
        if (!idname)
        {
            return this.backgroundLayer;
        }
        else
        {
            for(let i = 0; i < this.backgroundLayerExt.length; i++)
            {
                if (this.backgroundLayerExt[i].get('idname') === idname)
                {
                    return this.backgroundLayerExt[i];
                }
            }

            return null;
        }

    }

    /**
     * Gibt die Hintergrundkarten-Layer zurück (alle)
     */
    public getBackgroundLayers() {
        return this.backgroundLayerExt;
    }

    /**
     * Gibt den Overlay-Layer zurück
     */
    public getOverlayLayer() {
        return this.overlayLayer;
    }

    /**
     * Gibt die Style-Definitionen zurück
     */
    public getPointStyles() {
        return this.pointStyles;
    }

    /**
     * Setzt die Style-Definitionen
     * @param styles
     */
    public setPointStyles(styles: object) {
        this.pointStyles = styles;

        return this;
    }

    /**
     * Gibt eine spezielle Style-Definition zurück
     * @param {string} key      Spezieller Schlüsselname
     * @param {string} geotype  Geotyp des Features (point, line, polygon) (Fallback-Schlüssel)
     */
    public getPointStyle(key: string, geotype?:string) {
        if(this.pointStyles[key]) {
            this.debug('KEY gefunden:' + key);
            return this.pointStyles[key];
        }

        geotype = geotype.toLowerCase();

        switch(geotype)
        {
            case 'linestring':
            case 'multiline':
                geotype = 'line';
                break;
            case 'multipolygon':
                geotype = 'polygon';
                break;
        }

        if(geotype && this.pointStyles['__' + geotype]) {
            this.debug('GEOTYPE gefunden:' + geotype);
            return this.pointStyles['__' + geotype];
        }
        if(this.pointStyles['default_point']) {
            this.debug('DEFAULT_POINT gefunden');
            return this.pointStyles['default_point'];
        }
        return null;
    }

    /**
     * Fügt eine spezielle Style-Definition hinzu
     * @param key
     * @param style
     */
    public addPointStyle(key: string, style: object) {
        this.pointStyles[key] = style;

        return this;
    }

    /**
     * Fügt eine Style-Definition für einen PUNKT hinzu
     * @param key
     * @param url
     * @param color
     * @param opacity
     * @param anchor
     */
    public addPointstyleIcon(key: string, url: string, color: any, opacity: number, anchor: [number, number]) {
        if (!key) return;
        if (!url) return;

        opacity = typeof opacity !== "undefined" ? parseFloat(opacity.toString())  : this.defaultValues.opacity;
        anchor = anchor && Array.isArray(anchor) ? anchor : this.defaultValues.anchor;

        let option: object = {
            anchor: anchor,
            anchorXUnits: "fraction",
            anchorYUnits: "fraction",
            src: url,
            scale: 1,
            opacity: opacity
        };
        if (color && color !== '#000000') {
            option['color'] = color;
        }

        this.debug('ICON-Style: ' + key);
        this.debug(option);

        this.addPointStyle(key, new this.ol.style.Style({
            image: new this.ol.style.Icon(option)
        }));

        return this;
    }


    /**
     * Fügt eine Style-Definition für einen KREIS hinzu
     * @param key
     * @param radius
     * @param fillColor
     * @param borderColor
     * @param stroke
     * @param opacity
     */
    public addPointstyleCircle(key: string, radius: number, fillColor: any, borderColor: any, stroke: number, opacity: number) {
        if (!key) return;
        if (!radius) return;

        // console.log(fillColor);

        radius = typeof radius !== "undefined" ? parseInt(radius.toString()) : this.defaultValues.radius;
        fillColor = !fillColor ? '' : fillColor;
        stroke = typeof stroke !== "undefined" ? parseInt(stroke.toString()) : this.defaultValues.strokeWidth;
        borderColor = !borderColor ? this.defaultValues.strokeColor : borderColor;
        opacity = typeof opacity !== "undefined" ? parseFloat(opacity.toString()) : this.defaultValues.opacity;

        let strokeObj: object = {
            color: borderColor,
            width: stroke
        };

        let fillObjInstance = null;
        if (fillColor) {
            fillObjInstance = new this.ol.style.Fill({color: this.getRGBA(fillColor, opacity)});
        }

        let option: object = {
            radius: radius,
            fill: fillObjInstance,
            stroke: new this.ol.style.Stroke(strokeObj),
            opacity: opacity
        };

        this.debug('CIRCLE-Style: ' + key);
        this.debug(option);

        this.addPointStyle(key, new this.ol.style.Style({
            image: new this.ol.style.Circle(option)
        }));

        return this;
    }

    /**
     * Fügt eine Style-Definition für ein POLYGON hinzu
     * @param key
     * @param fillColor
     * @param borderColor
     * @param stroke
     * @param opacity
     */
    public addPointstylePolygon(key: string, fillColor: any, borderColor: any, stroke: number, opacity: number) {
        if (!key) return;

        fillColor = !fillColor ? '' : fillColor; // this.defaultValues.fillColor
        stroke = typeof stroke !== "undefined" ? parseInt(stroke.toString()) : this.defaultValues.strokeWidth;
        borderColor = !borderColor ? this.defaultValues.strokeColor : borderColor;
        opacity = typeof opacity !== "undefined" ? parseFloat(opacity.toString()) : this.defaultValues.opacity;

        let strokeObj: object = {
            color: borderColor,
            width: stroke
        };

        let fillObjInstance = null;
        if (fillColor) {
            fillObjInstance = new this.ol.style.Fill({color: this.getRGBA(fillColor, opacity)});
        }

        let option: object = {
            fill: fillObjInstance,
            stroke: new this.ol.style.Stroke(strokeObj),
            opacity: opacity
        };

        this.debug('POLYGON-Style: ' + key);
        this.debug(option);

        this.addPointStyle(key, new this.ol.style.Style(option));

        return this;
    }

    /**
     * Fügt eine Style-Definition für eine LINIE hinzu
     * @param key
     * @param borderColor
     * @param stroke
     * @param opacity
     */
    public addPointstyleStroke(key: string, borderColor: any, stroke: number, opacity: number) {
        if (!key) return;

        stroke = typeof stroke !== "undefined" ? parseInt(stroke.toString()) : this.defaultValues.strokeWidth;
        borderColor = !borderColor ? this.defaultValues.strokeColor : borderColor;
        opacity = typeof opacity !== "undefined" ? parseFloat(opacity.toString()) : this.defaultValues.opacity;

        let strokeObj: object = {
            color: borderColor,
            width: stroke
        };

        let option: object = {
            stroke: new this.ol.style.Stroke(strokeObj),
            opacity: opacity
        };

        this.debug('LINE-Style: ' + key);
        this.debug(option);

        this.addPointStyle(key, new this.ol.style.Style(option));

        return this;
    }

    /**
     * Transformiert eine Objekt mit verschiedenen Style-Konfigurationen in die interne Style-Definitionen
     * siehe $GLOBALS['GeoCMS_OL_Styles']
     * @param styleOptions
     */
    public setStyles(styleOptions: any) {

        if (styleOptions.icon) {
            for (let key in styleOptions.icon) {
                if (styleOptions.icon.hasOwnProperty(key)) {
                    let src = styleOptions.icon[key].src ? styleOptions.icon[key].src : '';
                    let color = styleOptions.icon[key].color ? styleOptions.icon[key].color : null;
                    let opacity = styleOptions.icon[key].opacity ? styleOptions.icon[key].opacity * 1 : this.defaultValues.opacity;
                    let anchor = styleOptions.icon[key].anchor ? styleOptions.icon[key].anchor : this.defaultValues.anchor;

                    this.addPointstyleIcon(key, src, color, opacity, anchor);
                }
            }
        }

        if (styleOptions.circle) {
            for (let key in styleOptions.circle) {
                if (styleOptions.circle.hasOwnProperty(key)) {
                    let radius = styleOptions.circle[key].radius ? styleOptions.circle[key].radius * 1 : 10;
                    let stroke = styleOptions.circle[key].stroke ? styleOptions.circle[key].stroke * 1 : 2;
                    let fillcolor = styleOptions.circle[key].fillcolor ? styleOptions.circle[key].fillcolor : '';
                    let strokecolor = styleOptions.circle[key].strokecolor ? styleOptions.circle[key].strokecolor : 'blue';
                    let opacity = styleOptions.circle[key].opacity ? styleOptions.circle[key].opacity * 1 : 1.0;

                    this.addPointstyleCircle(key, radius, fillcolor, strokecolor, stroke, opacity);
                }
            }
        }

        if (styleOptions.polygon) {
            for (let key in styleOptions.polygon) {
                if (styleOptions.polygon.hasOwnProperty(key)) {
                    let stroke = styleOptions.polygon[key].stroke ? styleOptions.polygon[key].stroke * 1 : 2;
                    let fillcolor = styleOptions.polygon[key].fillcolor ? styleOptions.polygon[key].fillcolor : '';
                    let strokecolor = styleOptions.polygon[key].strokecolor ? styleOptions.polygon[key].strokecolor : 'blue';
                    let opacity = styleOptions.polygon[key].opacity ? styleOptions.polygon[key].opacity * 1 : 1.0;

                    this.addPointstylePolygon(key, fillcolor, strokecolor, stroke, opacity);
                }
            }
        }

        if (styleOptions.line) {
            for (let key in styleOptions.line) {
                if (styleOptions.line.hasOwnProperty(key)) {
                    let stroke = styleOptions.line[key].stroke ? styleOptions.line[key].stroke * 1 : 2;
                    let strokecolor = styleOptions.line[key].strokecolor ? styleOptions.line[key].strokecolor : 'blue';
                    let opacity = styleOptions.line[key].opacity ? styleOptions.line[key].opacity * 1 : 1.0;

                    this.addPointstyleStroke(key, strokecolor, stroke, opacity);
                }
            }
        }

        return this;
    }


    /**
     * Fügt die Optionen für eine Control hinzu. Dadurch wird das Control aktiviert
     * @param key
     * @param _options
     */
    public addControls(key: string, _options: any) {
        let instance = this;
        let options = {};
        if (typeof _options === "undefined") {
            _options = {};
        }

        switch (key) {
            case 'GeolocationButton':
                options['delay'] = '3000';
                this.jquery.extend(options, _options);

                let geoloc = new this.ol.control[key](options);
                let geoloc_btn = this.jquery(geoloc.button_);
                if (geoloc_btn)
                {
                    geoloc_btn.attr('title',options['tipLabel'] ? options['tipLabel'] : 'Zentriert Karte auf die Ihre Position.');
                }

                // Show position
                let here = new this.ol.Overlay.Popup({ positioning: 'bottom-center' });
                this.getMap().addOverlay(here);
                geoloc.on('position', function(e) {
                    //console.log(e);

                    if (e.coordinate) {
                        here.show(e.coordinate, "<div style='text-align: center'>Sie sind<br/>hier!</div>");
                        if (!instance.GeolocationButtonInProgress && instance.isEditable() && instance.isAddFeaturePossible()) {
                            instance.GeolocationButtonInProgress = true;
                            setTimeout(function () {
                                let check = confirm('Den ermittelten Punkt auf der Karte erzeugen?');
                                     if (check) {
                                         instance.addSimpleFeature(e.coordinate, null, 'Standort');
                                     }
                            }, 2000);
                        }
                    }
                    else {
                        here.hide();
                        instance.GeolocationButtonInProgress = false;
                    }

                    // if (instance.isEditable() && instance.isAddFeaturePossible()) {
                    //
                    //     instance.getMap().getView().animate({
                    //         center:e.coordinate,
                    //         zoom: Math.max (instance.getMap().getView().getZoom(),instance.defaultValues.maxZoom)
                    //     });
                    //
                    //     let check = confirm('Sie sind hier! Punkt auf der Karte erzeugen?');
                    //     if (check) {
                    //         instance.addSimpleFeature(e.coordinate, null, 'Standort');
                    //     }
                    // }
                    // else
                    // {
                    //
                    // }

                });

                this.mapControls[this.mapControls.length] = geoloc;
                break;
            case 'Attribution':
                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'FullScreen':
                options['tipLabel'] = 'Wechselt zwischen voller Seite-Ansicht hin und her';

                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'MousePosition':
                options['projection'] = 'EPSG:4326';
                options['coordinateFormat'] = function (coordinate) {
                    return instance.ol.coordinate.format(coordinate, '{y}, {x}', 8);
                }

                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);

                break;
            case 'OverviewMap':
                if (this.overviewLayer) {
                    options['className'] = 'ol-overviewmap ol-custom-overviewmap';
                    options['layers'] = [this.overviewLayer];
                    options['tipLabel'] = 'Blendet verkleinerte Übersichtskarte ein';
                    options['rotateWithView'] = true;

                    this.jquery.extend(options, _options);
                    this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                }
                break;
            case 'Rotate':
                options['tipLabel'] = 'Orientiert die Karte wieder nach Norden';

                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'Scale':
                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'ScaleLine':
                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'ZoomSlider':
                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'ZoomToExtent':
                options['label'] = 'Z';
                options['tipLabel'] = 'Zoom auf alle aktuellen Punkte';
                //options['extent'] = this.featureLayer.getSource().getExtent();

                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'Zoom':
                options['duration'] = 500;
                options['zoomInTipLabel'] = 'Zoom in die Karte hinein';
                options['zoomOutTipLabel'] = 'Zoom aus der Karte heraus';

                this.jquery.extend(options, _options);
                this.mapControls[this.mapControls.length] = new this.ol.control[key](options);
                break;
            case 'LayerSwitcher':
                options['show_progress'] = true;
                options['trash'] = true;
                options['reordering'] = true;

                this.jquery.extend(options, _options);
                if (options['targetname'])
                {
                    options['target'] = this.jquery(options['targetname']).get(0);
                }

                // Alte Variante ...
                let with_info = false;
                if (options['info']) {
                    with_info = true;
                    // options['oninfo'] = function (l) {
                    //     //console.log(l);
                    //     instance.openDialog(l.get('info_id'),l.get('info_type'),'','',l);
                    // };
                }
                //console.log(this.ol.control.LayerSwitcher.prototype.tip);

                this.ol.control.LayerSwitcher.prototype.tip = {
                    up: "Hoch/Runter",
                    down: "Runter",
                    info: "Informationen...",
                    extent: "Zoom auf Extent",
                    trash: "Layer entfernen",
                    plus: "Auf-/Zuklappen",
                };

                this.jquery.extend(options, _options);

                let  switcher = new this.ol.control[key](options);
                let btn = this.jquery(switcher.button);
                if (btn)
                {
                    btn.attr('title',options['tipLabel'] ? options['tipLabel'] : 'Ebenenverwaltung...');
                }


/*                if (options['info'])
                {
                    switcher.on('info', function(e) {
                        let layer = e.layer;
                        console.log(layer);
                        let message = layer.get('description');
                        if (message) {
                            alert(message);
                        }
                    });
                }*/

                if (with_info)
                {
                    // Zusätzlicher Button für den Legenden-Dialog im LayerSwitcher
                    switcher.on('drawlist', function(e) {
                        let l = e.layer;
                        if (l && l.get('show_info') && (l.get('info_type') == 'cat' || l.get('info_type') == 'html')) {
                            instance.jquery('<div title="Information">').addClass('layerInfo')
                                .click(function () {
                                    // console.log('l=',l);
                                    instance.openDialog(l.get('info_id'), l.get('info_type'), '', '', l);
                                })
                                .appendTo(instance.jquery('> .ol-layerswitcher-buttons', e.li));
                        }
                    });
                }

                // Zusätzlicher Button für den Legenden-Dialog im LayerSwitcher
                switcher.on('drawlist', function(e) {
                    let l = e.layer;
                    if (l && l.get('show_legend') && l.get('info_type') == 'cat') {
                        instance.jquery('<div title="Legende">').addClass('layerLegend')
                            .click(function () {
                                instance.openDialog(l.get('info_id'), l.get('info_type'), 'Legende', 'show=legend');
                            })
                            .appendTo(instance.jquery('> .ol-layerswitcher-buttons', e.li));
                    }
                });
                this.mapControls[this.mapControls.length] = switcher;
                break;
            case 'LegendDialog':
                let legendDialogButton = new this.ol.control.Button (
                    {
                        html: '<i class="icon icon-list"></i>',
                        className: "ol-legenddialog",
                        title: "Legende für alle sichtbaren Layer",
                        handleClick: function(e)
                        {
                            let collector = [];
                            instance.getMap().getLayers().forEach(function(layer,i) {
                                let sublayers = layer.get('layers');
                                if (sublayers) {
                                    sublayers.forEach(function (l, j) {
                                        // Nur Layer aus dem Kategoriebaum und die sichtbar sind nutzen
                                        if (l.getVisible() && l.get('info_type') === 'cat') {
                                            collector.push(l.get('info_id'));
                                        }
                                    });
                                }
                            });

                            if (collector) {
                                let modul   = instance.jquery('#'+instance.getTargetId());
                                let url     = instance.getInfoUrl();
                                url         = url.replace('_INFO_ID_', collector.toString()).replace('_INFO_TYPE_', 'cat');
                                url         = url + '&show=legend';

                                let options = {
                                    title: 'Legenden',
                                    footer: true,
                                    ajaxUrl: '',
                                    options: {
                                        append: modul,
                                        description: {
                                            close: {
                                                caption: "Schließen"
                                            }
                                        }
                                    }
                                }
                                // @ts-ignore
                                BtpDialogClass.invokeDirect(options, url);
                            }
                        }
                    });
                this.mapControls[this.mapControls.length] = legendDialogButton;
                break;
            case 'SearchNominatim':

                options['label']        = 'Gehe zu';
                options['placeholder']  = 'Gehe zu ...';
                options['className']    = 'ol-search-nominatim';

                options['polygon']  = false;
                options['reverse']  = false;
                options['position'] = true; // Suche, mit Priorität auf die GeoPosition

                this.jquery.extend(options, _options);
                let search = new this.ol.control[key](options);

               search.on('select', function(e)
                {
                    //console.log(e);
                    let map = instance.getMap();

                    // Check if we get a geojson to describe the search
                    if (e.search.geojson) {
                        let format = new instance.ol.format.GeoJSON();
                        let f = format.readFeature(e.search.geojson, { dataProjection: "EPSG:4326", featureProjection: map.getView().getProjection() });
                        let view = map.getView();
                        let resolution = view.getResolutionForExtent(f.getGeometry().getExtent(), map.getSize());
                        let zoom = view.getZoomForResolution(resolution);
                        let center = instance.ol.extent.getCenter(f.getGeometry().getExtent());
                        // console.log('IF ----------------------------------- ');
                        // console.log('zoom = ', zoom);
                        // console.log('instance.getMaxGeocoderZoom() = ', instance.getMaxGeocoderZoom());
                        // redraw before zoom
                        setTimeout(function(){
                            view.animate({
                                center: center,
                                zoom: Math.min (zoom, instance.getMaxGeocoderZoom())
                            });
                        }, 100);
                    }
                    else {
                        // console.log('THEN ----------------------------------- ');
                        // console.log('map.getView().getZoom() = ', map.getView().getZoom());
                        // console.log('instance.getMaxGeocoderZoom() = ', instance.getMaxGeocoderZoom());
                        map.getView().animate({
                            center:e.coordinate,
                            zoom: Math.max (map.getView().getZoom(),instance.getMaxGeocoderZoom())
                        });

                        if (instance.isEditable() && instance.isAddFeaturePossible()) {
                            setTimeout(function(){
                                let check = confirm('Koordinaten-Objekt auf der Karte erzeugen?');
                                if (check) {
                                    let title = e.search.display_name ? e.search.display_name : 'Neuer Punkt';
                                    title = title.substring(0,99);
                                    instance.addSimpleFeature(e.coordinate, null, title);
                                }
                            }, 2000);
                        }
                    }
                });

                this.mapControls[this.mapControls.length] = search;
                break;
        }

        return this;
    }

    /**
     * Fügt die Optionen für eine Interaction hinzu. Dadurch wird die Interaction aktiviert
     * @param key
     * @param _options
     */
    public addInteractions(key: string, _options: any) {
        let options = {};
        let self    = this;

        if (typeof _options === "undefined") {
            _options = {};
        }


        // this.mapInteractions[this.mapInteractions.length] = new this.ol.interaction.Select({
        //    layers: function(layer) {
        //        if (layer && layer.idname && layer.idname == 'trackingLayer')
        //        {
        //            return true;
        //        }
        //        else
        //        {
        //            return false;
        //        }
        //    }
        // });

        switch (key) {

            case 'Select':
                this.jquery.extend(options, _options);
                let popup = typeof options["popup"] !== "undefined" ? options["popup"] : 0;
                if (popup)
                {
                    let popup = new this.ol.Overlay.Popup (
                        {	popupClass: "default", //"tooltips", "warning" "black" "default", "tips", "shadow",
                            closeBox: true,
                            onshow: function(){ console.log("You opened the box"); },
                            onclose: function(){ console.log("You close the box"); },
                            positioning: 'auto',
                            autoPan: true,
                            autoPanAnimation: { duration: 250 }
                        });

                        let select = new this.ol.interaction[key](options);
                        let self = this;

                        // On selected => show/hide popup
                        select.getFeatures().on(['add'], function(e) {
                            let feature = e.element;
                            let content = "";
                            content += feature.get("title");
                            popup.show(feature.getGeometry().getFirstCoordinate(), content);
                        });
                        select.getFeatures().on(['remove'], function(e) {
                            popup.hide();
                        })
                    }
                break;

            case 'DragBox':
                this.jquery.extend(options, _options);
                let dragBox = new this.ol.interaction[key](options);
                dragBox.on('boxend', function() {
                    let nextent = dragBox.getGeometry().getExtent();
                    self.map.getView().fit(nextent, {
                        maxZoom: self.defaultValues.maxZoom,
                        duration: self.defaultValues.duration
                    });
                });

                this.mapInteractions[this.mapInteractions.length] = dragBox;
                break;

            case 'DragPan':
                this.jquery.extend(options, _options);
                options['condition'] = function (event) {
                    // @ts-ignore
                    let isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
                    return (!isTouch && this.getPointerCount() === 1) || (isTouch && this.getPointerCount() === 2) || self.ol.events.condition.platformModifierKeyOnly(event);
                };
                let dragPan = new this.ol.interaction[key](options);
                this.mapInteractions[this.mapInteractions.length] = dragPan;
                break;

            default:
                this.jquery.extend(options, _options);
                this.mapInteractions[this.mapInteractions.length] = new this.ol.interaction[key](options);

        }

        return this;
    }

    /**
     * Transformiert eine Objekt mit verschiedenen Control/Interaction-Konfigurationen in die interne Darstellung
     * @param options
     */
    public setControlsAndInteractions(options: any) {

        if (options.graticule) {
            this.initGraticuleLayer();
        }

        if (options.controls) {
            for (let key in options.controls) {
                if (options.controls.hasOwnProperty(key))
                {
                    this.addControls(key, options.controls[key]);
                }
            }
        }

        if (options.interactions) {
            for (let key in options.interactions) {
                if (options.interactions.hasOwnProperty(key)) {
                    this.addInteractions(key, options.interactions[key]);
                }
            }
        }

        return this;
    }

    /**
     * Erstelle eine Liste von möglichen Background-Layern
     * @param layers
     */
    public addBackgroundLayerList(layers: any[]) {
        let option: any = null;
        for(let layer of layers)
        {
            switch(layer.type)
            {
                case 'basic':
                    this.addBasicBackgroundLayer(layer.name);
                    break;
                case 'wmts':
                    this.addWMTSBackgroundLayer(layer.title, layer.name, layer.url, layer.params, layer.attributions ? layer.attributions : '', 0, {});
                    break;
                case 'wms':
                    option = {
                        title: layer.title,
                        info_id: typeof layer.info_id !== "undefined" ? layer.info_id : null,
                        info_type: typeof layer.info_type !== "undefined" ? layer.info_type : null,
                        show_info: typeof layer.show_info !== "undefined" ? layer.show_info : null,
                        show_legend: typeof layer.show_legend !== "undefined" ? layer.show_legend : null,
                        source: new this.ol.source.TileWMS({
                            url: layer.url,
                            params: {LAYERS: layer.name, STYLES: layer.style, FORMAT: 'image/png'},
                            serverType: 'geoserver',
                            //ration: 1,
                            attributions: layer.attributions
                        })
                    };
                    this.__addBackgroundLayer(layer.name,option);
                    break;
            }
        }
    }

    private __addBackgroundLayer(idName:string, option: any)
    {
        if (option) {
            option['baseLayer'] = true;
            option['visible'] = false;
            option['idname'] = 'backgroundLayer_' + idName;

            if (this.restrictedExtent)
            {
                option['extent'] = this.restrictedExtent;
            }

            if (!this.backgroundLayer) {
                // Erster BackgroundLayer
                option['allwaysOnTop']      = true;      // Immer Oben
                option['noSwitcherDelete']  = true;  // Kann nicht gelöscht werden
                option['visible']           = true;
                this.backgroundLayer = new this.ol.layer.Tile(option);
                this.overviewLayer = new this.ol.layer.Tile(option);
                this.backgroundLayerExt.push(this.backgroundLayer);
            } else {
                this.backgroundLayerExt.push(new this.ol.layer.Tile(option));
            }
        }
    }

    /**
     *
     * @param theme z.B. osm, webatlas, webatlas_grau, topplus, topplus_grau
     */
    public addBasicBackgroundLayer(theme: string) {
        let currentDate:Date = new Date();
        let option: any = null;
        switch (theme) {

            case 'basemap':
            case 'webatlas':
                option = this.getBackgroundOption_BaseMapDe(theme, 'de_basemapde_web_raster_farbe','BASEMAP.DE');
                // https://sgx.geodatenzentrum.de/wms_webatlasde.light/?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities
                // option = {
                //     title: 'WebAtlas',
                //     source: new this.ol.source.TileWMS({
                //         url: 'https://sgx.geodatenzentrum.de/wms_webatlasde.light',
                //         params: {LAYERS: 'webatlasde.light', 'STYLES': '', FORMAT: 'image/png'},
                //         serverType: 'geoserver',
                //         attributions: '© GeoBasis-DE / BKG (' + currentDate.getFullYear() + ')'
                //     })
                // };

                break;

            case 'basemap_grau':
            case 'webatlas_grau':
                option = this.getBackgroundOption_BaseMapDe(theme, 'de_basemapde_web_raster_grau','BASEMAP.DE GRAU');

                // option = {
                //     title: 'WebAtlas (Grau)',
                //     source: new this.ol.source.TileWMS({
                //         url: 'https://sgx.geodatenzentrum.de/wms_webatlasde.light_grau',
                //         params: {LAYERS: 'webatlasde.light_grau', 'STYLES': '', FORMAT: 'image/png'},
                //         serverType: 'geoserver',
                //         attributions: '© GeoBasis-DE / BKG (' + currentDate.getFullYear() + ')'
                //     })
                // };
                break;

            case 'topplus':
                option = this.getBackgroundOption_TopPlus(theme, 'web','TopPlus');
                break;
            case 'topplus_grau':
                option = this.getBackgroundOption_TopPlus(theme, 'web_grau','TopPlus GRAU');
                break;

            case 'osm':
                option = {
                    title: 'OSM',
                    source: new this.ol.source.OSM({url: 'https://tile.openstreetmap.de/{z}/{x}/{y}.png'})
                };
        }

        this.__addBackgroundLayer(theme,option);

        return this;
    }

    /**
     *
     * @param title
     * @param name
     * @param url
     * @param params
     * @param attributions
     * @param is_visible
     * @param _options
     */
    public addWMTSBackgroundLayer(title:string, name:string, url: string, params: any, attributions: string, is_visible:number, _options: any) {

        if (typeof _options === "undefined") {
            _options = {};
        }

        // ---
        let options = {
            title: (title ? title : name) + ' (WMTS)',
            info_id: 1,
            info_type: 'html',
            show_info: 1
        };

        this.jquery.extend(options, _options);
        this.debug(options);


        let layerName       = params.layer ? params.layer : name;
        let matrixSetName   = params.matrixSet ? params.matrixSet : '';
        let idExtName       = params.id_extention ? params.id_extention : '';
        let idName          = layerName + '_' + matrixSetName + '_' + idExtName;


        this.__addBackgroundLayer(idName,options);

        // ---
        let instance    = this;
        let epsg        = this.getViewProjection();

        // console.log(url);
        // console.log(params);
        fetch(url)
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                let myparser = new instance.ol.format.WMTSCapabilities();

                let result = myparser.read(text);
                //console.log('-------------------- result ----------------------');
                //console.log(result);
                //console.log(params);
                let optionParams:object = {
                    layer: params.layer ? params.layer : name,
                    matrixSet: params.matrixSet,
                    projection: params.projection || epsg
                };
                //console.log(optionParams);
                let options = instance.ol.source.WMTS.optionsFromCapabilities(result, optionParams);
                //console.log('-------------------- option ----------------------');
                //console.log(options);
                if (options) {
                    options.crossOrigin = '';
                    options.projection = params.projection || epsg;
                    options.wrapX = false;
                    options.attributions = attributions ? attributions : (result.ServiceIdentification.Fees ? result.ServiceIdentification.Fees : result.ServiceProvider.ProviderName);

                    let l = instance.getBackgroundLayer('backgroundLayer_' + idName);
                    if (l) {
                        instance.debug(result.ServiceIdentification);
                        if (!l.get('title')) {
                            l.set('title', result.ServiceIdentification.Title);
                        }
                        l.set('abstract', result.ServiceIdentification.Abstract);
                        l.setSource(new instance.ol.source.WMTS(options));
                    }
                }
                else {
                    console.error('Options nach Aufruf von [' + url + '] ist null!');
                }
            });


        return null;
    }


    /**
     *
     */
    public createAdditionalFeatureLayer(title?: string) {
        let instance = this;
        title = title ? title : 'Feature-Layer ' + (this.additionalFeatureLayer.length + 1);
        let featureLayer = new this.ol.layer.Vector({
            idname: 'addfeatureLayer' + (this.additionalFeatureLayer.length + 1),
            title: title,
            info_type: 'html',
            info_id: 'featureLayer_info',
            show_info: 1,

            // --- LayerSwitcher-Optionen
            allwaysOnTop: true,      // Immer Oben
            noSwitcherDelete: true,  // Kann nicht gelöscht werden
            // --------------------------

            source: new this.ol.source.Vector({}),
            style: function (feature) {
                //console.log('+++++++++ feature +++++++++++');
                //console.log(feature);

                let type = feature.get('type');
                let geometry_type = feature.get('geometry_type') ?? feature.getGeometry().getType();
                let s: any = null;
                if (type || geometry_type) {
                    s = instance.getPointStyle(type, geometry_type);
                }
                if (!s) {
                    return new instance.ol.style.Style({
                        fill: new instance.ol.style.Fill({
                            color: '#33ffc5',
                        }),
                        stroke: new instance.ol.style.Stroke({
                            color: '#3377ff',
                            width: 2,
                        }),
                        image: new instance.ol.style.Circle({
                            radius: 7,
                            fill: new instance.ol.style.Fill({
                                color: '#ff3374',
                            }),
                        }),
                    });
                }

                return s;
            }
        });

        return featureLayer;
    }


    /**
     *
     * @param {GCPortalkarteVectorLayerOptions} options
     */
    public initVectorLayerForFeature(options: GCPortalkarteVectorLayerOptions) {

        // console.log('---------- options',options);

        let instance = this;
        return  new this.ol.layer.Vector({
            idname: options.idname,
            title: options.title,
            info_type: 'html',
            info_id: options.idname + '_info',
            show_info: 1,

            // --- LayerSwitcher-Optionen
            allwaysOnTop:true,      // Immer Oben
            noSwitcherDelete:true,  // Kann nicht gelöscht werden
            // --------------------------

            /*
            function (feature) {
                //console.log('+++++++++ feature +++++++++++');
                //console.log(feature);

                let type = feature.get('type');
                let geometry_type = feature.get('geometry_type') ?? feature.getGeometry().getType();
                let s: any = null;
                if (type || geometry_type) {
                    s = instance.getPointStyle(type, geometry_type);
                }
                if (!s) {
                    return new instance.ol.style.Style({
                        fill: new instance.ol.style.Fill({
                            color: '#33ffc5',
                        }),
                        stroke: new instance.ol.style.Stroke({
                            color: '#3377ff',
                            width: 2,
                        }),
                        image: new instance.ol.style.Circle({
                            radius: 7,
                            fill: new instance.ol.style.Fill({
                                color: '#ff3374',
                            }),
                        }),
                    });
                }

                return s;
            }
             */

            source: new this.ol.source.Vector({}),
            style: function (feature) {
                let type = feature.get('type');
                let geometry_type = feature.get('geometry_type') ?? feature.getGeometry().getType();
                let s:any = null;

                if (type || geometry_type) {
                    s =  instance.getPointStyle(type,geometry_type);
                }
                if (!s) {
                    return new instance.ol.style.Style({
                        fill: new instance.ol.style.Fill({
                            color: options.fill_color,
                        }),
                        stroke: new instance.ol.style.Stroke({
                            color: options.stroke_color,
                            width: 2,
                        }),
                        image: new instance.ol.style.Circle({
                            radius: 7,
                            fill: new instance.ol.style.Fill({
                                color: options.circle_color,
                            }),
                        }),
                        opacity: 0.5
                    });
                }

                return s;
            }
        });
    }

    /**
     *
     */
    public initFeatureLayer(title?: string) {

        let options:GCPortalkarteVectorLayerOptions = {
            idname: 'featureLayer',
            title: title ? title : 'Feature-Layer',
            fill_color: '#33ffc5',
            stroke_color: '#3377ff',
            circle_color: '#ff3374'
        }
        this.featureLayer = this.initVectorLayerForFeature(options);
        return this;
    }

    /**
     *
     * @param title
     */
    public initDirectFeatureLayer(title?:string) {

        let options:GCPortalkarteVectorLayerOptions = {
            idname: 'directFeatureLayer',
            title: title ? title : 'DirectFeature-Layer',
            fill_color:     this.getRGBA('#ffcc33',0.3),
            stroke_color:   this.getRGBA('#ffcc33',0.5),
            circle_color:   this.getRGBA('#ffcc33',0.5)
        }

        this.directFeatureLayer = this.initVectorLayerForFeature(options);
        return this;
    }

    /**
     *
     */
    public initGraticuleLayer() {
        this.graticuleLayer = new this.ol.layer.Graticule({
            idname: 'graticuleLayer',
            title: 'Gradgitter',            // ggf. Titel (z.B. im LayerSwitcher)
            displayInLayerSwitcher: false,  // im LayerSwitcher nicht anzeigen

            // the style to use for the lines, optional.
            strokeStyle: new this.ol.style.Stroke({
                color: 'rgba(255,120,0,0.9)',
                width: 2,
                lineDash: [0.5, 4]
            }),
            showLabels: true,
            wrapX: false
        });

        return this;
    }

    /**
     *
     */
    public initOverlayLayer() {
        this.jquery('body').append('<div class="arrow_box" id="' + this.getTargetId() + '-popup-container"><div id="' + this.getTargetId() + '-popup-content" class="text-dark"></div></div>');
        this.overlayLayer = new this.ol.Overlay({
            idname: 'infoLayer',
            id: 'info_overlay',
            element: document.getElementById(this.getTargetId() + '-popup-container'),
            positioning: 'bottom-center',
            offset: [0, -20],
            stopEvent: true,
            autoPan: true
        });

        return this;
    }



    /**
     *
     * @param title
     * @param name
     * @param description
     * @param layers
     * @param attributions
     * @param is_visible
     * @param _options
     */
    public addWMS(title:string, name:string, description: string, layers: GCPortalkarteWMSLayerInterface[], attributions: string, is_visible:number, _options: any) {

        if (typeof _options === "undefined") {
            _options = {};
        }

        this.wmsLayer = [];
        for (let layer of layers)
        {

            if (typeof layer.options === "undefined") {
                layer.options = {};
            }

            this.addWMSLayer(layer.title, layer.name, layer.url, layer.no_tiled, layer.params, layer.attributions, layer.is_visible,
                {
                    info_id: typeof layer.options.info_id !== "undefined" ? layer.options.info_id : null,
                    info_type: typeof layer.options.info_type !== "undefined" ? layer.options.info_type : null,
                    show_info: typeof layer.options.show_info !== "undefined" ? layer.options.show_info : 0,
                    show_legend: typeof layer.options.show_legend !== "undefined" ? layer.options.show_legend : 0,
                    getfeatureinfo: typeof layer.options.getfeatureinfo !== "undefined" ? layer.options.getfeatureinfo : 0,
                    description: layer.description,
                    bbox: typeof layer.bbox !== "undefined" ? layer.bbox : null,
                }
            );
        }

        let options: object = {
            title: title,
            idname: name,
            description: description,
            visible: !!is_visible,
            layers: this.wmsLayer.reverse()
        };

        this.jquery.extend(options, _options);
        this.debug(options);

        let wmsgroup = new this.ol.layer.Group(options);
        this.wmsLayerGroup.push(wmsgroup);

        return this;
    }


    /**
     *
     * @param title
     * @param name
     * @param url
     * @param no_tiled
     * @param params
     * @param attributions
     * @param is_visible
     * @param _options
     */
    public addWMSLayer(title: string, name: string, url: string, no_tiled: number, params: any, attributions: string, is_visible: number, _options: any) {

        if (typeof _options === "undefined") {
            _options = {};
        }

        /*
            Single Image WMS
            https://openlayers.org/en/latest/examples/wms-image.html

            source: ImageWMS
            layer: Image
         */

        let bbox    = _options.bbox ?? null;
        //console.log('---- bbox', bbox);
        //console.log('---- params', params);
        let extent  = null;
        if (bbox && bbox.minx)
        {
            let minPoint  = [ bbox.minx, bbox.miny ];
            let maxPoint  = [ bbox.maxy, bbox.maxy ];
            const dataCRS = bbox.crs ?? 'EPSG:4326';
            const featureProj = this.getViewProjection(); // params.CRS ? params.CRS :

            //console.log('---- dataCRS',dataCRS);
            //console.log('---- featureProj',featureProj);

            minPoint = this.ol.proj.transform(minPoint, dataCRS, featureProj);
            maxPoint = this.ol.proj.transform(maxPoint, dataCRS, featureProj);
            extent   = [minPoint[0], minPoint[1], maxPoint[0], maxPoint[1]];
        }
        //console.log('---- extent',extent);


        if (no_tiled) {
            let source = new this.ol.source.ImageWMS({
                url: url,
                params: params,
                attributions: attributions,
                serverType: 'geoserver',
                ratio: 1.5,
                projection: this.getViewProjection() //params.CRS ? params.CRS : this.getViewProjection()
            });

            let options: object = {
                title: title ? title : name,
                visible: !!is_visible,
                source: source,
                idname: name
            };

            if (extent)
            {
                options = {
                    title: title ? title : name,
                    visible: !!is_visible,
                    extent: extent,
                    source: source,
                    idname: name
                };
            }

            this.jquery.extend(options, _options);
            this.debug(options);

            let obj = new this.ol.layer.Image(options);
            this.debug(obj);
            this.wmsLayer.push(obj);

            return this;
        } else {
            let source = new this.ol.source.TileWMS({
                url: url,
                params: params,
                attributions: attributions,
                serverType: 'geoserver',
                projection: params.CRS ? params.CRS : this.getViewProjection()
            });

            let options: object = {
                title: title ? title : name,
                visible: !!is_visible,
                source: source,
                idname: name
            };

            if (extent)
            {
                options = {
                    title: title ? title : name,
                    visible: !!is_visible,
                    extent: extent,
                    source: source,
                    idname: name
                };
            }

            this.jquery.extend(options, _options);
            this.debug(options);

            let obj = new this.ol.layer.Tile(options);
            this.debug(obj);
            this.wmsLayer.push(obj);

            return this;
        }


    }

    /**
     * Ermittelt einen Layer nach einem gegebenen Schlüsselnamen
     * @param key
     */
    public getWMSLayer(key):any {
        let result = {};
        for (let layer of this.wmsLayer)
        {
            let idname = layer.get('idname');
            if (idname == key) {
                result = layer;
            }
        }
        return result;
    }

    /**
     *
     * @param featureDefinition
     * @param {boolean} is_direct
     * @param {any} to_layer
     */
    public addFeature(featureDefinition: any, is_direct: boolean = false, to_layer: any = null) {
        let id = typeof featureDefinition.id !== "undefined" && featureDefinition.id ? featureDefinition.id : this.idCounter++;
        let unique_id = typeof featureDefinition.unique_id !== "undefined" && featureDefinition.unique_id ? featureDefinition.unique_id : id;
        unique_id = 'UID_' + unique_id;

        let title = typeof featureDefinition.title !== "undefined" && featureDefinition.title ? featureDefinition.title : 'Punkt ' + id;
        let description = typeof featureDefinition.desc !== "undefined" && featureDefinition.desc ? featureDefinition.desc : '';
        let url = typeof featureDefinition.url !== "undefined" && featureDefinition.url ? featureDefinition.url : null;
        let url_target = typeof featureDefinition.url_target !== "undefined" && featureDefinition.url_target ? featureDefinition.url_target : null;
        let info_url = typeof featureDefinition.info_url !== "undefined" && featureDefinition.info_url ? featureDefinition.info_url : null;
        let coords = typeof featureDefinition.coords !== "undefined" && featureDefinition.coords ? featureDefinition.coords : null;
        let poly = typeof featureDefinition.poly !== "undefined" && featureDefinition.poly ? featureDefinition.poly : null;
        let wkt = typeof featureDefinition.wkt !== "undefined" && featureDefinition.wkt ? featureDefinition.wkt : null;
        let crs = typeof featureDefinition.crs !== "undefined" && featureDefinition.crs ? featureDefinition.crs : this.defaultValues.mapViewProjection; //'EPSG:3857';
        let type = typeof featureDefinition.type !== "undefined" && featureDefinition.type ? featureDefinition.type : 'standard';
        let style = typeof featureDefinition.style !== "undefined" && featureDefinition.style ? featureDefinition.style : {};
        let geometry_type = typeof featureDefinition.geometry_type !== "undefined" && featureDefinition.geometry_type ? featureDefinition.geometry_type : 'point';

        let icon = typeof featureDefinition.icon !== "undefined" && featureDefinition.icon ? featureDefinition.icon : '';

        if (coords && crs != this.defaultValues.mapViewProjection) {
            this.debug('Punkt: Vor Transformation: ' + coords);
            coords = this.ol.proj.transform(coords, crs, this.defaultValues.mapViewProjection);
            this.debug('Punkt: Nach Transformation: ' + coords);
        }

        let geometry = new this.ol.geom.Point(coords);

        if ((geometry_type == 'multipolygon' || geometry_type == 'polygon' || geometry_type == 'line' || geometry_type == 'multiline') && wkt) {
            let projection  = crs;
            geometry        = null;
            if (wkt && projection) {
                const format = new this.ol.format.WKT();
                try {
                    const feature = format.readFeature(wkt, {
                        dataProjection:    projection,
                        featureProjection: this.getViewProjection(),
                    });
                    geometry = feature.getGeometry();
                }
                catch (e) {
                    console.error('WKT konnte nicht korrekt gelesen werden.');
                    console.error(wkt);
                }
            }
            icon = '';
        }

        if ((geometry_type == 'multipolygon' || geometry_type == 'polygon') && style.unique_id) {
            this.addPointstylePolygon(style.unique_id, style.fillColor, style.strokeColor, style.strokeWidth, style.opacity ? parseFloat(style.opacity) : 1.0);
            type = style.unique_id;
        }

        if ((geometry_type == 'multiline' ||geometry_type == 'line') && style.unique_id) {
            this.addPointstyleStroke(style.unique_id, style.strokeColor, style.strokeWidth, 1.0);
            type = style.unique_id;
        }

        if (geometry_type == 'point' && style.unique_id) {
            this.addPointstyleCircle(style.unique_id, 7, style.fillColor, style.strokeColor, style.strokeWidth, style.opacity ? parseFloat(style.opacity) : 1.0);
            type = style.unique_id;
        }

        if (icon) {
            this.addPointstyleIcon(icon, icon, null, 1.0, [0.5, 1.0]);
            type = icon;
        }

        this.debug(featureDefinition);
        if (!coords || !geometry) {
            return this;
        }

        let feature = new this.ol.Feature({
            geometry: geometry,
            labelPoint: new this.ol.geom.Point(coords),
            crs: crs,
            name: title,
            description: description,
            type: type,
            geometry_type: geometry_type,
            url: url ? url : null, //'<a href="'+url+'" target="'+url_target+'>' + title + '</a>'
            url_target: url_target ? url_target : null,
            info_url: info_url ? info_url : null,
            unique_id: unique_id,
            coord_id: id
        });


        if (to_layer) {
            // Direktes Zuweisen zu einem Feature-Layer (additionalFeatureLayer)
            to_layer.getSource().addFeature(feature);
            this.featureCounter++;
        } else {
            if (is_direct) {
                if (this.directFeatureLayer && this.directFeatureLayer.getSource())
                {
                    // console.log('-------------------------- addfeature');
                    this.directFeatureLayer.getSource().addFeature(feature);

                    // console.log('-------------------------- this.callAs',this.callAs);
                    if (this.callAs !== 'edit') {
                        // --- TODO: Diese darf im Fall von XControls nicht angewendet werden!
                        // In Fall der XControls sind Features für den DirectLayer nur zur Ansicht und haben keinen
                        // Einfluss auf die Position der Karte bzw. die Zoom-Tiefe
                        if (!this.directFeatureCounter) {
                            this.firstPoint = coords;
                        }
                        this.directFeatureCounter++;
                        // ------------------------------------------------------------------
                    }
                }

            } else {

                this.featureLayer.getSource().addFeature(feature);

                if (!this.featureCounter) {
                    this.firstPoint = coords;
                }

                this.featureCounter++;
            }
        }

        return this;
    }


    /**
     *
     * @param _coords
     * @param _crs
     * @param _title
     */
    public addSimpleFeature(_coords: [number,number], _crs: string, _title: string) {

        let id: number  = this.idCounter++;
        let unique_id: string =  id.toString();
        unique_id = 'UID_' + unique_id;

        let title = typeof _title !== "undefined" && _title ? _title : 'Punkt ' + id;
        let url =  null;
        let url_target = null;
        let coords = typeof _coords !== "undefined" && _coords ? _coords : null;
        let crs = typeof _crs !== "undefined" && _crs ? _crs : this.defaultValues.mapViewProjection; //'EPSG:3857';
        let type = 'default_point';
        let geometry_type = 'point';

        if (coords) {
            this.debug('Vor Transformation: ' + coords);
            coords = this.ol.proj.transform(coords, crs, this.defaultValues.mapViewProjection);
            this.debug('Nach Transformation: ' + coords);
        }

        if (!coords) {
            return this;
        }

        let geometry = new this.ol.geom.Point(coords);
        let feature = new this.ol.Feature({
            geometry: geometry,
            labelPoint: new this.ol.geom.Point(coords),
            crs: crs,
            name: title,
            title: title,
            type: type,
            geometry_type: geometry_type,
            url: url ? url : null, //'<a href="'+url+'" target="'+url_target+'>' + title + '</a>'
            url_target: url_target ? url_target : null,
            unique_id: unique_id,
            coord_id: id
        });

        this.getCurrentLayer().getSource().addFeature(feature);
        if (!this.featureCounter)
        {
            this.firstPoint  = geometry.getCoordinates();
        }

        this.featureCounter++;

        return this;
    }

    /**
     *
     * @param info_id
     * @param info_type
     * @param title
     * @param url_ext
     * @param layer
     */
    public openDialog(info_id:any,info_type:string, title?:string, url_ext?:string, layer?:any)
    {
        // console.log('--- openDialog ---');
        // console.log(info_id);
        // console.log(info_type);
        // console.log(layer);
        let modul:any       = window['jQuery']('#' + this.getTargetId());
        let message = 'Keine Infos';
        if (info_type == 'html' && layer) {

            let layer_abstract = layer.get('abstract');
            if (!layer_abstract) {
                let temp = layer.get('json');
                if (temp) {
                    layer_abstract = temp.abstract;
                }
            }

            let options = {
                title: title ? title : 'Informationen',
                footer: true,
                options: {
                    append: modul,
                    description: {
                        close: {
                            caption: "Schließen"
                        }
                    }
                }
            }

            // @ts-ignore
            let dialog = BtpDialogClass.invokeDirect(options, '', true);
            dialog.setContent(layer_abstract);

            return false;
        }
        if (typeof info_id !== "undefined" && typeof info_type !== "undefined" && info_type == 'html') {
            let container = this.jquery('#' + info_id);
            if (container) {

                let options = {
                    title: title ? title : 'Informationen',
                    footer: true,
                    options: {
                        append: modul,
                        description: {
                            close: {
                                caption: "Schließen"
                            }
                        }
                    }
                }

                // @ts-ignore
                let dialog = BtpDialogClass.invokeDirect(options, '', true);
                dialog.setContent(container.html());
            }
            return false;
        } else {
            let url = this.getInfoUrl();
            if (typeof info_id !== "undefined" && url) {
                url = url.replace('_INFO_ID_', info_id.toString()).replace('_INFO_TYPE_', info_type);
                if (url_ext) {
                    url = url + '&' + url_ext;
                }
                let options = {
                    title: title ? title : 'Informationen',
                    footer: true,
                    ajaxUrl: '',
                    options: {
                        append: modul,
                        description: {
                            close: {
                                caption: "Schließen"
                            }
                        }
                    }
                }

                // @ts-ignore
                BtpDialogClass.invokeDirect(options, url);
                return false;
            }
        }

        alert(message);
        return false;
    }

    /**
     *
     * @param {number][]} startPoint IMMER IN EPSG:4326 bzw. WSG84
     */
    public initMap(startPoint: number[]) {
        this.map.setTarget(this.getTargetId());

        this.debug(this.defaultValues.maxZoom);

        let viewOptions:any = {
            center: this.ol.proj.fromLonLat(startPoint,this.defaultValues.mapViewProjection),
            zoom: this.defaultValues.maxZoom,
            minZoom: this.defaultValues.minZoomSteps,
            maxZoom: this.defaultValues.maxZoomSteps,
            projection: this.defaultValues.mapViewProjection
        };

        this.debug(viewOptions);

        let view = new this.ol.View(viewOptions);

        if (this.proj4Extent)
        {
            //console.log(this.proj4Extent);
            view.getProjection().setExtent(this.proj4Extent);
        }
        this.map.setView(view);

        return this;
    }

    /**
     *
     * @param {number}  startzoom  Initiale Zoomtiefe
     * @param {boolean} forceStartZoom Default-Wert = false, erzwingt die Nutzerung des Startzoom's
     * @param {number}  fit_zoom    Maximale Zoomtiefe für automatischen Zooming durch die fit-Methode
     */
    public renderMap(startzoom: number, forceStartZoom: boolean = false, fit_zoom: number = 0) {

        if (startzoom <= 0) {
            startzoom = this.defaultValues.maxZoom;
        }

        if (fit_zoom <= 0) {
            fit_zoom = this.defaultValues.maxZoom;
        }

        // Hintergrund-Layer einbinden -------------------------------------------------------------
        if (this.backgroundLayerExt) {
            let basegroup = new this.ol.layer.Group({
                    title: 'Hintergrundkarten',
                    idname: 'basis_map',

                    // --- LayerSwitcher-Optionen
                    allwaysOnTop:false,         // ist nicht "Immer oben"
                    noSwitcherDelete:true,      // Kann nicht gelöscht werden
                    // --------------------------

                    layers: this.backgroundLayerExt.reverse()
                });
            this.map.addLayer(basegroup);
        }

        // WMS Layer einbinden ----------------------------------------------------------------------
        if (this.wmsLayerGroup && this.wmsLayerGroup.length) {
            for (let group of this.wmsLayerGroup.reverse()) {
                this.map.addLayer(group);
            }
        }


        let layerExtents = [];

        // Wenn DirectFeatures gesetzt wurden, dann Feature-Layer anzeigen (pos=1 bedeutet, VOR den Featurelayer)
        if (this.directFeatureLayer && this.directFeatureCounter && this.directFeatureLayer.get('pos')) {
            this.map.addLayer(this.directFeatureLayer);
           layerExtents.push(this.directFeatureLayer.getSource().getExtent());
            this.debug('---- layerExtents directFeatureLayer');
            this.debug(layerExtents);
        }

        // Wenn Features gesetzt wurden, dann Feature-Layer anzeigen
        if (this.featureLayer && this.featureCounter) {

            // Es kann mehr als einen FeatureLayer geben
            if (this.additionalFeatureLayer) {
                for (let j = this.additionalFeatureLayer.length; j > 0; j--) {
                    this.map.addLayer(this.additionalFeatureLayer[j - 1]);

                    layerExtents.push(this.additionalFeatureLayer[j - 1].getSource().getExtent());
                }
            }

            // Der Hauptlayer kommt über die zusätzlichen Layer
            this.map.addLayer(this.featureLayer);
            layerExtents.push(this.featureLayer.getSource().getExtent());

            this.debug('---- layerExtents featureLayer');
            this.debug(layerExtents);
        }

        // Wenn DirectFeatures gesetzt wurden, dann Feature-Layer anzeigen (pos=0 bedeutet, NACH den Featurelayer)
        if (this.directFeatureLayer && this.directFeatureCounter && !this.directFeatureLayer.get('pos')) {
            this.map.addLayer(this.directFeatureLayer);
           layerExtents.push(this.directFeatureLayer.getSource().getExtent());

            this.debug('---- layerExtents directFeatureLayer');
            this.debug(layerExtents);
        }

        // Graticule-Layer anzeigen
        if (this.graticuleLayer) {
            this.map.addLayer(this.graticuleLayer);
        }

        // Overlay-Layer anzeigen
        if (this.overlayLayer) {
            this.map.addOverlay(this.overlayLayer);
        }

        // Controls auf die Karte setzen
        for (let i = 0; i < this.mapControls.length; i++) {
            this.map.addControl(this.mapControls[i]);
        }

        // Interaktionen zur Karte hinzufügen
        for (let i = 0; i < this.mapInteractions.length; i++) {
            this.map.addInteraction(this.mapInteractions[i]);
        }

        // Startansichten (Mittelpunkt und Zoomtiefe) festlegen/interpretieren
        /*
            1. Es kann eine Startansicht erzwungen werden, egal ob Features bereitstehen oder nicht
            2. Die Startansicht nicht erzwungen werden soll:
                2.a. Liegen keine Feature vor, dann Starteinstellungen nutzen
                2.b. Liegt ein Feature vor, Feature zentrieren und Zoom bis maximal Start oder FitZoom
                2.c. Zentrum ermitteln und maximal bis FitZoom hineinzoomen

         */
        
        let currentExtent =  this.getExtent(layerExtents);

        this.debug('---- layerExtents');
        this.debug(layerExtents);
        this.debug('---- currentExtent');
        this.debug(currentExtent);
        this.debug('---- fit_zoom');
        this.debug(fit_zoom);

        if (currentExtent && currentExtent.length)
        {
            this.map.getView().fit(currentExtent, {
                maxZoom: fit_zoom,
                duration: this.defaultValues.duration
            });
        }
        else
        {
            this.debug('startzoom= ' + startzoom);
            this.map.getView().setZoom(startzoom);
        }



        /*
        let featureCounter: any = this.featureCounter + this.directFeatureCounter;

        this.debug('featureCounter: ' + featureCounter);
        this.debug('forceStartZoom: ' + forceStartZoom);
        if (nextent && featureCounter > 0 ) {
            if (featureCounter > 1 && !forceStartZoom) {
                this.debug('fit_zoom= ' + fit_zoom);
                this.map.getView().fit(nextent, {
                    maxZoom: fit_zoom,
                    duration: this.defaultValues.duration
                });
            }
            else
            {
                this.debug('startzoom= ' + startzoom);
                this.debug('fit_zoom= ' + fit_zoom);
                this.debug('firstPoint= ' + this.firstPoint.toString());
                if (forceStartZoom)
                {
                    this.debug('mit startzoom: ' + startzoom);
                    this.map.getView().setCenter(this.firstPoint);
                    this.map.getView().setZoom(startzoom);
                }
                else
                {
                    this.debug('mit fit_zoom: ' + fit_zoom);
                    this.map.getView().setCenter(this.firstPoint);
                    this.map.getView().setZoom(fit_zoom);
                }

            }
        } else {
            this.debug('startzoom= ' + startzoom);
            this.map.getView().setZoom(startzoom);
        }

         //*/

        // Prüfung, ob Layer mit abrufbaren FeatureInfo's angezeigt werden, aktivieren
        this.defaultOnPointermove();

        //return this;
    }

    /**
     *
     * @protected
     */
    protected getExtent(layerExtents:any[])
    {
        let currentExtent = null;
        if (layerExtents.length)
        {
            currentExtent = layerExtents[0];
            for(let i = 1; i < layerExtents.length; i++)
            {
                currentExtent = this.ol.extent.extend(currentExtent , layerExtents[i]);
            }
        }
        else
        {
            return null;
        }

        if (!currentExtent) return null;

        let nextent = [];
        let padding = this.defaultValues.extentPaddingFactor;

        let paddingx = (padding * (Math.abs(currentExtent[2] - currentExtent[0]))) / 100;
        let paddingy = (padding * (Math.abs(currentExtent[3] - currentExtent[1]))) / 100;
        this.debug('padding= ' + padding);
        this.debug('paddingx= ' + paddingx);
        this.debug('paddingy= ' + paddingy);

        nextent[0] = currentExtent[0] - paddingx;
        nextent[1] = currentExtent[1] - paddingy;
        nextent[2] = currentExtent[2] + paddingx;
        nextent[3] = currentExtent[3] + paddingy;

        let controls = this.map.getControls();
        for (let i = 0; i < controls.getLength(); i++) {

            if (this.featureCounter > 0 && controls.item(i) instanceof this.ol.control.ZoomToExtent) {
                controls.item(i).extent = nextent;
            } else if (this.featureCounter == 0 && controls.item(i) instanceof this.ol.control.ZoomToExtent) {
                this.map.removeControl(controls.item(i));
            }
        }

        return nextent;
    }

    /**
     *
     * @param func
     */
    public onFeatureClick(func: any) {
        if (func) {
            this.map.on('click', func);
        } else if (func === null) {
            this.map.on('click', this.defaultOnClick);
        }

        return this;
    }

    /**
     * Reaktion, wenn Maus über der Karte bewegt wird
     */
    public defaultOnPointermove()
    {
        this.getMap().isGetFeatureInfoActive = 0;
        if (this.isGetFeatureInfoActive())
        {
            this.getMap().isGetFeatureInfoActive = 1;
            let self:any = this;
            this.getMap().on('pointermove', function (evt) {
                if (evt.dragging) {
                    return;
                }
                let pixel:any   = self.getMap().getEventPixel(evt.originalEvent);
                let hit:any     = self.getMap().forEachLayerAtPixel(pixel, function (layer) {
                    return layer.get('getfeatureinfo')
                });
                self.getMap().getTargetElement().style.cursor = hit ? 'pointer' : '';
            });
        }
        else
        {
            this.getMap().on('pointermove', function (e) {
                if (e.dragging) {
                    return;
                }
                GCPortalkarteClass.defaultShowFeature(e, false, GCPortalkarteClass.only_first_feature);
            });

        }
    }


    /**
     * Hilfsfunktion für die GeoFeatureInfo bei Layern
     * @param e
     */
    public static  defaultGetFeatureInfo(e:any)
    {
            let map:any         = e.map;
            let idname:string   = map.get('target');
            let modul:any       = window['jQuery']('#' + idname);
            let modal:any       = window['jQuery']('#' + idname + '_modal');
            let modaldialog:any     = window['jQuery']('#' + idname + '_modal_dialog');
            let info:any        = window['jQuery']('#' + idname + '_info');
            let layerCollection:number = 0;

            // Dieses Flag verhindert, das bei einem Doppelklick die geoFeatureInfo ZWEIMAL abgefragt wird
            if (!map.modalStatus) {
                map.modalStatus = 1;

                map.forEachLayerAtPixel(e.pixel, function (layer) {
                    let properties = layer.getProperties();
                    if (typeof properties.source.getFeatureInfoUrl !== "undefined") {
                        let viewResolution = /** @type {number} */ (map.getView().getResolution());
                        let url = properties.source.getFeatureInfoUrl(
                            e.coordinate,
                            viewResolution,
                            map.getView().getProjection(),
                            {'INFO_FORMAT': 'text/html', 'FEATURE_COUNT': 100}
                        );

                        if (url) {
                            fetch('ws/cors-proxy/?source=' + encodeURIComponent(url))
                                .then(function (response) {
                                    return response.text();
                                })
                                .then(function (html) {
                                    if (html) {
                                        let nInfo: any = null;
                                        if (!layerCollection) {
                                            layerCollection = 1;
                                            modal.modal('dispose');
                                            info.empty();
                                            modal.on('hidden.bs.modal', function (event) { map.modalStatus = 0; });
                                            modal.appendTo(modul);
                                            modal.modal('show');

                                            modaldialog.draggable({
                                                handle: ".modal-header",
                                            });

                                            nInfo = window['jQuery']('<div class=""><div class="small text-muted d-none">' + properties.title + '</div>' + html + '</div>');
                                        } else {
                                            nInfo = window['jQuery']('<div class="mt-2 border-top"><div class="small text-muted d-none">' + properties.title + '</div>' + html + '</div>');
                                        }
                                        nInfo.appendTo(info);
                                    }
                                });
                        }
                        //console.log(url);
                    }
                }, {
                    hitTolerance: 1,
                    layerFilter: function (l) { return l.get('getfeatureinfo') }
                });
            } else {
                map.modalStatus = 0;
            }
    }


    /**
     * Hilfsfunktion für die Tooltip-Funktion bei Featuren
     * @param e
     * @param {boolean} fixed
     */
    public static defaultShowFeature(e: any, fixed: boolean = false, only_first = 1) {
        let markupContainer = {};
        let markup = '<ul class="list-group list-group-flush p-0 m-0 bg-transparent">';
        let elements = 0;

        // Feature unterhalb des Klicks sammeln
        let hit = e.map.forEachFeatureAtPixel(e.pixel, function (feature) {

            let properties = feature.getProperties();
            let description = '';
            let title = '';

            if (typeof properties.name !== "undefined" || typeof properties.title !== "undefined") {

                // console.log('properties.geometry', properties.geometry);
                // console.log('properties.geometry.getType()', properties.geometry.getType());

                title = properties.name ?? properties.title;
                description = properties.description;

                if (properties.url) {
                    // Prüfe, ob die URL ein Javascript-Aufruf ist (Kennung JS###)
                    let url = properties.url;
                    if (url.indexOf('JS###') !== -1) {
                        let temp = url.split('###');
                        url = temp[1];
                        markupContainer[properties.unique_id] = `<li class="list-group-item list-group-item-action p-0 bg-transparent"><a onclick="${url}; return false" href="#" target="${properties['url_target']}">${properties['name']}</a></li>`;
                    }
                    else
                    {
                        markupContainer[properties.unique_id] = `<li class="list-group-item list-group-item-action p-0 bg-transparent"><a href="${url}" target="${properties['url_target']}">${title}</a></li>`;
                    }

                } else {
                    if (description)
                    {
                        markupContainer[properties.unique_id] = `<li class="list-group-item list-group-item-action p-0 bg-transparent"><strong>${title}</strong><div class="small p-0 m-0" style="max-width: 200px !important">${description}</div></li>`;
                    }
                    else
                    {
                        markupContainer[properties.unique_id] = `<li class="list-group-item list-group-item-action p-0 bg-transparent"><strong>${title}</strong></li>`;
                    }

                }
                return only_first ? 1 : 0;
            }
        }, {hitTolerance: 1});


        // Nur wirklich unterschiedliche Daten ausgeben
        for (var item in markupContainer) {
            markup += markupContainer[item];
            elements++;
        }

        markup += '</ul>';



        let overlay     = e.map.getOverlayById('info_overlay');
        let useOverlay  = fixed ? 1 : !overlay.get('onclick')
        if (overlay && useOverlay) {
            let properties = e.map.getProperties();
            let document_id = properties.target + '-popup-content';
            if (elements) {
                document.getElementById(document_id).innerHTML = markup;
                overlay.setPosition(e.coordinate);
                if (fixed) overlay.set('onclick',1);
            } else {
                overlay.setPosition();
                if (fixed) overlay.set('onclick',0);
            }
        }
        e.map.getTargetElement().style.cursor = hit ? 'pointer' : '';
    }

    /**
     * Aktion, wenn auf die Karte geklickt wird
     * @param e
     */
    public defaultOnClick(e: any) {
        // getFeatureInfo (WMS) einbinden
        if (e.map.isGetFeatureInfoActive) {
            GCPortalkarteClass.defaultGetFeatureInfo(e);
        }
        // Feature-Info einblenden
        GCPortalkarteClass.defaultShowFeature(e, true, GCPortalkarteClass.only_first_feature);
    }

    /**
     *
     * @param value
     */
    protected debug(value: any) {
        if (this.debugOn) {
            console.log(value);
        }
    }


    /**
     * Erzeugen einer einfachen Kartenausgabe
     * @param _options
     * @param olContainer
     */
    public createSimpleMap(_options: any, olContainer: any[]) {
        if (typeof _options === "undefined") {
            _options = {};
        }

        let options = this.defaultValues;
        this.jquery.extend(options, _options);

        this.addPointstyleIcon('default_point', this.getUrl(options.mapDefaultPointIconPath), options.mapDefaultPointIconColor, options.mapDefaultPointIconOpacity, options.mapDefaultPointIconAnchor);
        this.addPointstyleCircle('default_circle', options.radius, options.fillColor, options.strokeColor, options.strokeWidth, options.opacity);
        this.addPointstylePolygon('default_polygon', options.fillColor, options.strokeColor, options.strokeWidth, options.opacity);
        this.addPointstyleStroke('default_line', options.strokeColor, options.strokeWidth, options.opacity);

        this.setMaxZoom(options.maxZoom)
        .setMaxZoomSteps(options.maxZoomSteps)
        .setExtentPaddingFactor(options.extentPaddingFactor)
        .addBasicBackgroundLayer(options.mapBackground) // Hintergrund-Karte setzen
        .initFeatureLayer() // Feature-Layer erzeugen
        .initDirectFeatureLayer() // DirectFeature-Layer erzeugen
        .initOverlayLayer() // Layer für Infobox erzeugen
        //.initTrackingLayer() // Layer für die Bearbeitung
        .onFeatureClick(null)
        .setControlsAndInteractions(options.mapCtrlOptions)
        .addInteractions('DoubleClickZoom',[])
        .addInteractions('DragPan',[]);

        for (let i = 0; i < olContainer.length; i++) {
            this.addFeature(olContainer[i]);
        }

        //this.addSimpleFeature(this.ol.proj.fromLonLat([11,51]),'EPSG:3857','testpunkt');

        // HTML-Container ermitteln und konfigurieren
        let html = this.jquery('#' + this.getTargetId());
        if (options.mapDynamic)
        {
            html.prop('style','min-width:'+ options.mapWidth +'px; height:' + options.mapHeight + 'px');
            html.addClass('w-100');
        }
        else
        {
            html.prop('style','width:'+ options.mapWidth +'px; height:' + options.mapHeight + 'px');
        }

        this.initMap(options.mapStartpoint);
        this.renderMap(options.mapStartzoom);

        return this;
    }

    /**
     *
     * @param {string} key
     */
    public getLayerByName(key:string)
    {
        let layers = this.map.getLayers().getArray();
        let result = {};
        for (let layer of layers)
        {
            let idname:string = layer.get('idname');
            if (idname == key) {
                result = layer;
            }
        }
        return result;
    }

    /**
     *
     * @param response
     */
    public onGeocoderResponse(response: any)
    {
        if (response)
        {
            let responseObj = new GCPortalkarteGeocoderResponseClass(this,response);
            responseObj.process();
        }
    }

    private getBackgroundOption_TopPlus(theme:string, layer:string, layerTitle:string)
    {
        let instance = this;
        let currentDate = new Date();
        let option = {};
        let withWmts = false;
        let matrixSet = '';
        let epsg = this.getViewProjection();
        switch (epsg)
        {
            case 'EPSG:25832':
                withWmts = true;
                matrixSet = 'EU_EPSG_25832_TOPPLUS';
                break;
            case 'EPSG:3857':
            case 'EPSG:900913':
                withWmts = true;
                matrixSet = 'WEBMERCATOR';
                break;
        }

        if (withWmts)
        {
            let myparser = new this.ol.format.WMTSCapabilities()
            let urlA = 'https://sg.geodatenzentrum.de/wmts_topplus_open/1.0.0/WMTSCapabilities.xml';
            fetch(urlA)
                .then(function (response) {
                    return response.text();
                })
                .then(function (text) {
                    let result = myparser.read(text);
                    let options = instance.ol.source.WMTS.optionsFromCapabilities(result, {
                        layer: layer,
                        matrixSet: matrixSet,
                    });
                    options.crossOrigin = '';
                    options.projection = epsg;
                    options.wrapX = false;
                    let attr1 = 'Kartendarstellung und Präsentationsgraphiken: © Bundesamt für Kartographie und Geodäsie ' + currentDate.getFullYear() + ', ';
                    let attr2 = 'Datenquellen: <a href="https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/Datenquellen_TopPlusOpen.html" target="_blank">https://sgx.geodatenzentrum.de/web_public/gdz/datenquellen/Datenquellen_TopPlusOpen.html</a>';
                    options.attributions = attr1 + attr2;

                    let l = instance.getBackgroundLayer('backgroundLayer_' + theme);
                    if (l) {
                        l.setSource(new instance.ol.source.WMTS(options));
                    }
                });
            option =
                {
                    title: layerTitle + ' (WMTS)',
                };
        }
        else
        {
            option = {
                title: layerTitle,
                source: new this.ol.source.TileWMS({
                    url: 'https://sgx.geodatenzentrum.de/wms_topplus_open',
                    params: {LAYERS: layer, 'STYLES': 'default', FORMAT: 'image/png'}, //, CRS: 'EPSG:3857'
                    attributions: '<a href="http://www.bkg.bund.de" target="">Bundesamt für Kartographie und Geodäsie</a> ' + currentDate.getFullYear() + ', <a href="http://sg.geodatenzentrum.de/web_public/Datenquellen_TopPlus_Open.pdf" target="_blank">Datenquellen</a>'
                })
            };
        }

        return option;
    }

    /**
     *
     * @param {string} theme
     * @param {string} layer
     * @param {string} layerTitle
     * @private
     *
     * <code>
     *
     * https://sgx.geodatenzentrum.de/wmts_basemapde/tile/1.0.0/de_basemapde_web_raster_grau/default/DE_EPSG_3857_ADV/04/171/273.png
     * https://sgx.geodatenzentrum.de/wmts_basemapde/tile/1.0.0/de_basemapde_web_raster_farbe/default/DE_EPSG_3857_ADV/04/171/273.png
     *
     * </code>
     */
    private getBackgroundOption_BaseMapDe(theme:string, layer:string, layerTitle:string)
    {
        let instance = this;
        let currentDate = new Date();
        let option = {};
        let withWmts = false;
        let matrixSet = '';
        let epsg = this.getViewProjection();
        switch (epsg)
        {
            case 'EPSG:25832':
                withWmts = true;
                matrixSet = 'DE_EPSG_25832_ADV';
                break;
            case 'EPSG:25833':
                withWmts = true;
                matrixSet = 'DE_EPSG_25833_ADV';
                break;
            case 'EPSG:3857':
                withWmts = true;
                matrixSet = 'DE_EPSG_3857_ADV';
                break;
            case 'EPSG:900913':
                withWmts = true;
                matrixSet = 'GLOBAL_WEBMERCATOR';
                break;
        }

        if (withWmts)
        {
            let myparser = new this.ol.format.WMTSCapabilities()
            let urlA = 'https://sgx.geodatenzentrum.de/wmts_basemapde/1.0.0/WMTSCapabilities.xml';
            fetch(urlA)
                .then(function (response) {
                    return response.text();
                })
                .then(function (text) {
                    let result = myparser.read(text);
                    let options = instance.ol.source.WMTS.optionsFromCapabilities(result, {
                        layer: layer,
                        matrixSet: matrixSet,
                    });
                    options.crossOrigin = '';
                    options.projection = epsg;
                    options.wrapX = false;
                    let attr1 = 'Kartendarstellung und Präsentationsgraphiken: © Bundesamt für Kartographie und Geodäsie ' + currentDate.getFullYear() + ', ';
                    let attr2 = 'Datenquellen: <a href="https://gdz.bkg.bund.de/index.php/default/webdienste/basemap-webdienste.html" target="_blank">https://gdz.bkg.bund.de/index.php/default/webdienste/basemap-webdienste.html</a>';
                    options.attributions = attr1 + attr2;

                    let l = instance.getBackgroundLayer('backgroundLayer_' + theme);
                    if (l) {
                        l.setSource(new instance.ol.source.WMTS(options));
                    }
                });
            option =
                {
                    title: layerTitle + ' (WMTS)',
                };
        }
        else
        {
            option = {
                // title: layerTitle,
                // source: new this.ol.source.TileWMS({
                //     url: 'https://sgx.geodatenzentrum.de/wms_topplus_open',
                //     params: {LAYERS: layer, 'STYLES': 'default', FORMAT: 'image/png'}, //, CRS: 'EPSG:3857'
                //     attributions: '<a href="http://www.bkg.bund.de" target="">Bundesamt für Kartographie und Geodäsie</a> ' + currentDate.getFullYear() + ', <a href="http://sg.geodatenzentrum.de/web_public/Datenquellen_TopPlus_Open.pdf" target="_blank">Datenquellen</a>'
                // })
            };
        }

        return option;
    }

    /**
     *
     * @param path
     */
    public setUrlPathExtension(path:string)
    {
        this.url_path_extension = path;
        return this;
    }

    /**
     *
     */
    public getUrlPathExtension()
    {
        return this.url_path_extension;
    }

    /**
     *
     * @param origin
     */
    public getUrl(origin:string) {
        if (this.url_path_extension && origin)
        {
            let temp = this.url_path_extension + origin;
            temp = temp.replace('//','/');
            return temp;
        }

        return origin;
    }

    /**
     *
     */
    public isAddFeaturePossible()
    {
        return true;
    }

    /**
     *
     * @param value
     */
    public setFeatureCounter(value:number)
    {
        this.featureCounter = value;
        return this;
    }

    public static onVisible(element, callback) {
        new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    callback(element);
                    observer.disconnect();
                }
            });
        }).observe(element);
    }

    public getRGBA(_color, alpha) {
        let color = _color.toString();
        if (color.length == 7) {
            let r = parseInt(color.substring(1, 3), 16);
            let g = parseInt(color.substring(3, 5), 16);
            let b = parseInt(color.substring(5), 16);
            let a = alpha ? alpha : 1;
            return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
        } else {
            return color;
        }
    }


    /**
     *
     * @param {string} url
     */
    public storeCurrentView(url:string)
    {
        if (url && window.confirm('Die Ansicht als Startansicht speichern?')) {
            const params = {
                center: this.getMap().getView().getCenter(),
                zoom: this.getMap().getView().getZoom(),
                proj: this.getMap().getView().getProjection().getCode()
            }

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams(params)
            });
        }
    }


    /**
     * Aktiviert das Control GeoPosition von extern.
     * @param id
     */
    public static trigger_geoposition(id:string)
    {
        let element = document.querySelector<HTMLElement>('#' + id + '_cont .ol-geobt');
        if (element && element.firstElementChild) {
            element.firstElementChild.dispatchEvent(new Event('click'));
        } else {
            alert('Auf der angezeigten Karte steht kein GeoLocation-Control zur Verfügung.')
        }
        return false;
    }

    /**
     *
     * @param id
     * @param geocodebtn
     */
    public static trigger_suche(id:string, geocodebtn:string)
    {
        let btn = document.getElementById(geocodebtn);
        if (btn && btn.dataset.address) {
            let element = document.querySelector<HTMLElement>('#' + id + '_cont .ol-search-nominatim');
            if (element) {
                element.childNodes[0].dispatchEvent(new Event('click'));
                let input = <HTMLInputElement>element.childNodes[1];
                input.value = btn.dataset.address;
                input.dispatchEvent(new Event('keyup'));

            } else {
                alert('Auf der angezeigten Karte steht kein Nominatim-Control zur Verfügung.')
            }
        }
        return false;
    }

}